/**
 * Configuração das camadas temáticas que devem estar visíveis por padrão no mapa
 *
 * Este arquivo centraliza a configuração de quais camadas do mapa devem iniciar visíveis
 * quando a aplicação é carregada. Apenas as camadas listadas aqui serão exibidas
 * inicialmente; todas as outras permanecerão ocultas até serem explicitamente ativadas
 * pelo usuário.
 */

// Lista de camadas que devem estar visíveis por padrão
export const defaultVisibleLayers = ['ÁREA DO IMÓVEL', 'SIGEF'];

/**
 * Verifica se uma camada específica deve estar visível por padrão
 * @param {string} layerName - Nome da camada a ser verificada
 * @returns {boolean} - true se a camada deve estar visível por padrão, false caso contrário
 */
export function isLayerVisibleByDefault(layerName) {
  return defaultVisibleLayers.includes(layerName);
}
